import React, {useState, useEffect} from 'react'

import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import ContentLoader from 'react-content-loader';

export default function TopicProgressChart(props) {
    
    const [ chartData, setChartData ] = useState(null);
    
    useEffect(() => {
        if (props.data) {
            const userCount = props.data.user_states.length;

            var result = props.data.topics.map((topic, topicIndex) => {
                var resolvedTaskCount = 0;
                var currentTaskLength = topic.tasks.length;

                props.data.user_states.map((user, userIndex) => {

                    var beforeTaskArray = props.data.topics.filter((filterEntry, filterIndex) => filterIndex < topicIndex).map(mapEntry => {
                        return mapEntry.tasks.length;
                    });

                    var beforeTaskCount = beforeTaskArray.length > 0 ? beforeTaskArray.reduce((a, b) => a + b) : 0;

                    var slicedParts = user.states.slice(beforeTaskCount, beforeTaskCount + currentTaskLength);

                    var countResolved = slicedParts.filter(x => x === true).length;

                    resolvedTaskCount += countResolved;
                });

                return ({
                    name: topic.title,
                    axisName: limitStringLength(topic.title, 15),
                    allTasksCount: topic.tasks.length,
                    maxPossibleResolutions: topic.tasks.length * userCount,
                    resolvedTasksCount: resolvedTaskCount,
                    topicIsMandatory: topic.mandatory
                });
            });

            setChartData(result);
        }
    }, []);

    const customLegend = (value, entry) => {
        return <span>{value.replace('resolvedTasksCount', 'Erledigt').replace('maxPossibleResolutions', 'Ausstehend')}</span>
    }

    return (
        <>
            {
                chartData != null ?
                <>
                    <b className="d-block text-center">Fortschritt von Themen</b>

                    <div style={{height: 300, overflowX: 'hidden'}}>
                        <ResponsiveContainer>
                            <BarChart
                                className="d-block mx-auto"
                                data={chartData}
                                margin={{
                                    top: 20,
                                    right: 30,
                                    left: 20,
                                    bottom: 5,
                                }}
                                >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="axisName" />
                                <YAxis />
                                <Tooltip content={<CustomTooltip />} />
                                <Legend formatter={customLegend} />
                                <Bar dataKey="resolvedTasksCount" stackId="a" fill="#82ca9d" />
                                <Bar dataKey="maxPossibleResolutions" stackId="a" fill="#8884d8" />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </>
                :
                <DummyBarChart />
            }
        </>
    )
}

function CustomTooltip({ payload, label, active }) {
    if (active) {
        return (
            <div className="rechart-custom-tooltip" style={{maxWidth: '250px'}}>
                <b style={{overflowWrap: 'break-word'}}>{payload[0].payload.name}</b>
                <p className="m-0">Gesamtanzahl Aufgaben: {payload[0].payload.allTasksCount}<br/>
                Erledigte Aufgaben: {payload[0].payload.resolvedTasksCount} / {payload[0].payload.maxPossibleResolutions}<br/>
                Pflicht: {payload[0].payload.topicIsMandatory ? "Ja" : "Nein"}</p>
            </div>
        );
    }
  
    return null;
}

function limitStringLength(value, maxLength = 20) {
    return value.length > maxLength ? `${value.substring(0, maxLength)}...` : value;
}

const DummyBarChart = props => {
    return (
        <ContentLoader width={200} height={200} viewBox="0 0 200 200" {...props}>
            <rect x="0" y="160" rx="0" ry="0" width="25" height="40" />
            <rect x="30" y="145" rx="0" ry="0" width="25" height="55" />
            <rect x="60" y="126" rx="0" ry="0" width="25" height="74" />
            <rect x="90" y="80" rx="0" ry="0" width="25" height="120" />
            <rect x="120" y="142" rx="0" ry="0" width="25" height="58" />
        </ContentLoader>
    )
}